var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableViewSelectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6149 4H1.62388C0.730746 4 0 3.28 0 2.4V1.6C0 0.72 0.730746 0 1.62388 0H14.6149C15.5081 0 16.2388 0.72 16.2388 1.6V2.4C16.2388 3.28 15.5081 4 14.6149 4ZM14.6149 6H1.62388C0.730746 6 0 6.72 0 7.6V8.4C0 9.28 0.730746 10 1.62388 10H14.6149C15.5081 10 16.2388 9.28 16.2388 8.4V7.6C16.2388 6.72 15.5081 6 14.6149 6ZM14.6149 12H1.62388C0.730746 12 0 12.72 0 13.6V14.4C0 15.28 0.730746 16 1.62388 16H14.6149C15.5081 16 16.2388 15.28 16.2388 14.4V13.6C16.2388 12.72 15.5081 12 14.6149 12Z",
    fill: "#2947FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableViewSelectedIcon);
export default __webpack_public_path__ + "static/media/tableViewSelectedIcon.3dafe155c7e0ba4bb45700dc5d365f97.svg";
export { ForwardRef as ReactComponent };